import * as React from "react";
import clsx from "clsx";
import { Eye, EyeOff } from "lucide-react";
import * as s from "../../FormInput.style.css";
import type { PasswordInputProps } from "./PasswordInput.types";

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput({ label, error, changed, hint, id, className, ...rest }, ref) {
    const inputId = id ?? React.useId();
    const [visible, setVisible] = React.useState(false);

    return (
      <div className={s.wrapper}>
        {label && (
          <label htmlFor={inputId} className={s.label}>
            {label}
          </label>
        )}
        <div className={s.passwordFieldWrapper}>
          <input
            ref={ref}
            type={visible ? "text" : "password"}
            id={inputId}
            className={clsx(s.input, s.passwordInput, changed && s.inputChanged, error && s.inputError, className)}
            aria-invalid={!!error}
            aria-describedby={error ? `${inputId}-error` : undefined}
            {...rest}
          />
          <button
            type="button"
            className={s.passwordToggle}
            onClick={() => setVisible((v) => !v)}
            tabIndex={-1}
            aria-label={visible ? "Hide password" : "Show password"}
          >
            {visible ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
        {hint && !error && <span className={s.hintText}>{hint}</span>}
        {error && (
          <span id={`${inputId}-error`} className={s.errorText} role="alert">
            {error}
          </span>
        )}
      </div>
    );
  }
);
